<app-default-layout>
  <div class="text-center">
    <h1 class="text-error">500</h1>
    <h3 class="mt-3 mb-2">Error de servidor</h3>
    <p class="text-muted mb-3">{{errorMessage}}</p>
    <a routerLink="/" class="btn btn-primary waves-effect waves-light">Volver atrás</a>
  </div>
</app-default-layout>
